const DOCS_ENV_PREFIX = "VITE_DOCS_";

const normalizeAlias = (alias: string): string => alias.trim().toUpperCase();

const getDocumentationUrl = (alias: string): string | undefined => {
  if (!alias) {
    return undefined;
  }

  const normalizedAlias = normalizeAlias(alias);
  const envKey = `${DOCS_ENV_PREFIX}${normalizedAlias}` as `VITE_DOCS_${string}`;

  return import.meta.env[envKey];
};

/**
 * Открывает страницу документации в новой вкладке по псевдониму.
 */
export const openDocumentation = (alias: string): void => {
  const docsUrl = getDocumentationUrl(alias);

  if (!docsUrl) {
    console.warn(`Документация для псевдонима "${alias}" не найдена.`);
    return;
  }

  if (typeof window === "undefined") {
    console.warn("Открытие документации возможно только в браузере.");
    return;
  }

  window.open(docsUrl, "_blank", "noopener,noreferrer");
};

/**
 * Возвращает ссылку на документацию по псевдониму.
 */
export const resolveDocumentationUrl = (alias: string): string | undefined => {
  return getDocumentationUrl(alias);
};
